import React from 'react';
import PropTypes from 'prop-types';
import { useStoreState } from 'easy-peasy';
import AddWidgetsDialogDragDrop from './AddWidgetsDialogDragDrop';
import EditTestimonialsDialog from './EditTestimonialsDialog';
import EditServicesDialog from './EditServicesDialog';
import EditAchievementsDialog from './EditAchievementsDialog';
import EditMainDialog from './EditMainDialog';
import EditContactSectionDialog from './EditContactSectionDialog';
import EditEbookSectionDialog from './EditEbookSectionDialog';
import EditVideoDialog from './EditVideoDialog';
import EditVideoSectionDialog from './EditVideoSectionDialog';
import EditWidgetDialog from './EditWidgetDialog';
import { EditAboutDialog } from './index';

const EditConfigurationDialog = (props) => {
	const { sectionId } = props;
	const templateId = useStoreState((state) => state.template.template);
	console.log(props);
	if (sectionId === '#section-testimonials') {
		return <EditTestimonialsDialog {...props} />;
	}
	if (sectionId === '#section-calculator') {
		if (props.widgetContainerId) {
			return <AddWidgetsDialogDragDrop {...props} />;
		}
		return <EditWidgetDialog {...props} />;
	}
	if (sectionId === '#section-accolades') {
		return <EditAchievementsDialog {...props} />;
	}
	if (sectionId === '#section-contact') {
		return <EditContactSectionDialog {...props} />;
	}
	if (sectionId === '#section-services') {
		return <EditServicesDialog {...props} />;
	}
	if (sectionId === '#section-main' || sectionId === '#section-main-hero') {
		if (templateId === 'template3') {
			return <EditAboutDialog {...props} />;
		}
		return <EditMainDialog {...props} />;
	}
	if (sectionId === '#section-about') {
		return <EditAboutDialog {...props} />;
	}
	if (sectionId === '#section-videos') {
		if (props.videoContainerId) {
			return <EditVideoDialog {...props} />;
		}
		return <EditVideoSectionDialog {...props} />;
	}
	if (sectionId === '#section-ebook') {
		return <EditEbookSectionDialog {...props} />;
	}

	return null;
};

EditConfigurationDialog.propTypes = {
	open: PropTypes.bool,
	sectionId: PropTypes.string,
	widgetContainerId: PropTypes.string,
	videoContainerId: PropTypes.string,
	handleClose: PropTypes.func,
};

export default EditConfigurationDialog;
